// extracted by mini-css-extract-plugin
export default {"log_container":"ViewLogsModal_log_container__JBvxj"};